import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { useSelector } from 'react-redux';

const GroupChart = ({ data, currency }) => {
    const colors = useSelector((state) => state?.persistedReducer?.colors);
  if (!Array.isArray(data)) {
    console.error("Invalid data: Expected an array", data);
    return <p>Error: Invalid data format</p>;
  }

  const validData = data
    .filter((item) => item && typeof item.name === "string" && !isNaN(parseFloat(item.total_income)))
    .map((item) => ({
      name: item.name,
      total_income: parseFloat(item.total_income) || 0,
    }));

  if (validData.length === 0) {
    return <p>No valid data available for the chart</p>;
  }

  const currencySymbol = currency?.currency_symbol || "$";

  const formatLabel = (value) => {
    if (value >= 1_000_000_000_000) {
      return `${currencySymbol}${(value / 1_000_000_000_000).toFixed(2)}T`;
    } else if (value >= 1_000_000_000) {
      return `${currencySymbol}${(value / 1_000_000_000).toFixed(2)}B`;
    } else if (value >= 1_000_000) {
      return `${currencySymbol}${(value / 1_000_000).toFixed(1)}M`;
    } else {
      return `${currencySymbol}${value.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })}`;
    }
  };
  const categories = validData.map((item) => item.name);
  const seriesData = validData.map((item) => item.total_income);

  const options = {
    chart: {
      type: "column",
    },
    title: {
      text: `Total Revenue per Group`,
      align: 'left',
         style: {
        color: colors?.secondary ?? '#000',
      },
    },
    credits: {
      enabled: false,
    },
    legend: {
      enabled: false,
    },
    xAxis: {
      categories,
      title: {
        text: "Groups",
      },
    },
    yAxis: {
      min: 0,
      title: {
        text: `Total Income (${currencySymbol})`,
      },
      labels: {
        formatter: function () {
          return formatLabel(this.value);
        },
      },
    },
    tooltip: {
      shared: true,
      formatter: function () {
        return `<b>${this.x}</b><br/>Total Income: <b>${formatLabel(this.y)}</b>`;
      },
    },
    plotOptions: {
      column: {
        dataLabels: {
          enabled: true,
          formatter: function () {
            return formatLabel(this.y, false);
          },
        },
      },
    },
    series: [
      {
        name: "Total Income",
        data: seriesData,
        colorByPoint: true,
      },
    ],
  };

  return <HighchartsReact highcharts={Highcharts} options={options} />;
};

export default GroupChart;
